import { ref } from 'vue';

export function useErrorHandling(error) {
  
  const type = ref("unknown");
  const data = ref(null);
  const code = ref(null);
  const message = ref(null);
  
  
  if (error.response) {
    code.value = error.response.status;
    switch (error.response.status) {
      case 401:
      case 403:
        type.value = "unauthorized";
        message.value = error.response.data.message;        
        break;
      case 422:
        type.value = "validation";
        message.value = error.response.data.message;
        data.value = error.response.data.errors;
        break;
      case 423:
        type.value = "locked";
        message.value = error.response.data.message;
        data.value = error.response.data.errors;
        break;
      case 500:
        type.value = "server-error";
        message.value = error.response.data.message;
        break;
      default:
        type.value = "response";
        message.value = error.response.data.message;
        data.value = error.response.data;
        break;
    }
  } else if (error.request) {
    type.value = "request";
    data.value = error.request;
  } else {
    type.value = "setup";
    message.value = error.message;
  }

  return { type, data, code, message };
}